import React, { useRef } from "react";
import { useEffect, useContext } from "react";
import BruttoNettoContext from "../../BruttoNettoRechnerKomponenten/BruttoNettoContext";
import extDGZKmSFLAF from "./extDGZKmSFLAF";
import extDGZMV from "./extDGZMV";
import extDGZSV from "./extDGZSV";
import { Tooltip as ReactTooltip } from "react-tooltip";

export default function ErgDGZ() {
  const { bruttoNettoState, handleBruttoNettoState } =
    useContext(BruttoNettoContext);

  const bruttoGehalt = bruttoNettoState.bruttoGehalt;
  const safeHandleBruttoNettoState = useRef(handleBruttoNettoState);

  useEffect(() => {
    console.log("useEffect running");
    const abgabenBerechnen = () => {
      const { kd, rabatt } = extDGZKmSFLAF(bruttoGehalt);
      safeHandleBruttoNettoState.current("ergDGZkd", kd);
      safeHandleBruttoNettoState.current("ergDGZkdr", rabatt);
      safeHandleBruttoNettoState.current("ergDGZkdNetto", kd - rabatt);

      const dgSV = extDGZSV(bruttoGehalt);
      safeHandleBruttoNettoState.current("ergDGSV", dgSV);

      const dgMV = extDGZMV(bruttoGehalt);
      safeHandleBruttoNettoState.current("ergDGMV", dgMV);
      const dgZgesamt = dgSV + dgMV + kd - rabatt;
      safeHandleBruttoNettoState.current("ergDGgesamt", dgZgesamt);
      console.log(bruttoNettoState);
    };

    abgabenBerechnen();
  }, [bruttoGehalt, safeHandleBruttoNettoState]);

  return (
    <div>
      <p className="dg_zuschläge lead">
        <b>DG-Zuschläge lfd. & SZ</b>
      </p>
      <div className="result trc1">
        DG-Anteil SV{" "}
        <span className="tooltip" data-tooltip-id="tooltip10">
          ℹ️
        </span>
        :
        <span className="help_float_right">
          {bruttoNettoState.ergDGSV &&
            bruttoNettoState.ergDGSV.toLocaleString("de-DE", {
              maximumFractionDigits: 2,
            })}
          €
        </span>
      </div>
      <div className="result trc2">
        KommS & FLAF{" "}
        <span className="tooltip" data-tooltip-id="tooltip11">
          ℹ️
        </span>
        :
        <span className="help_float_right">
          {bruttoNettoState.ergDGZkd &&
            bruttoNettoState.ergDGZkd.toLocaleString("de-DE", {
              maximumFractionDigits: 2,
            })}
          €
        </span>
      </div>
      <div className="result trc1">
        KF-Rabatt{" "}
        <span className="tooltip" data-tooltip-id="tooltip12">
          ℹ️
        </span>
        :
        <span className="help_float_right">
          {bruttoNettoState.ergDGZkdr &&
            bruttoNettoState.ergDGZkdr.toLocaleString("de-DE", {
              maximumFractionDigits: 2,
            })}
          €
        </span>
      </div>

      <div className="result trc2">
        Mitarbeitervsg.{" "}
        <span className="tooltip" data-tooltip-id="tooltip13">
          ℹ️
        </span>
        :
        <span className="help_float_right">
          {bruttoNettoState.ergDGMV &&
            bruttoNettoState.ergDGMV.toLocaleString("de-DE", {
              maximumFractionDigits: 2,
            })}
          €
        </span>
      </div>
      <div className="net-cost trc1 result">
        gesamt:
        <span className="help_float_right">
          {bruttoNettoState.ergDGgesamt &&
            bruttoNettoState.ergDGgesamt.toLocaleString("de-DE", {
              maximumFractionDigits: 2,
            })}
          €
        </span>
      </div>
      <ReactTooltip id="tooltip10" place="bottom" variant="info">
        <p>Keine Wohnbauförderungsumlage. </p>
        <p>Kein DGZ für LK-Umlage. </p>
      </ReactTooltip>
      <ReactTooltip id="tooltip11" place="bottom" variant="info">
        <p>3% Kommunalsteuer. </p>
        <p>3,7% Dienstgeberbeitrag zum FLAF. </p>
      </ReactTooltip>
      <ReactTooltip id="tooltip12" place="bottom" variant="info">
        <p>Bis zur mtl. Lohnsumme von 1.460€ gilt ein Abzug von 1.095€. </p>
        <p>Dabei sind alle im Betrieb gezahlten Löhne maßgeblich.</p>
      </ReactTooltip>
      <ReactTooltip id="tooltip13" place="bottom" variant="info">
        <p>1,53%, ab dem 2. Dienstmonat.</p>
      </ReactTooltip>
    </div>
  );
}
